function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(242, 234, 213)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'army': 'rgb(75, 83, 32)','athletic-heather': 'rgb(178, 171, 161)','baby-blue': 'rgb(137, 207, 240)','berry': 'rgb(139, 58, 98)','cardinal': 'rgb(140, 29, 64)','cardinal-red': 'rgb(140, 29, 64)','dark-grey-heather': 'rgb(62, 60, 61)','dark-heather': 'rgb(69, 69, 69)','graphite-heather': 'rgb(86, 101, 115)','heather-brown': 'rgb(107, 68, 35)','heather-clay': 'rgb(182, 110, 65)','heather-grey': 'rgb(176, 176, 176)','heather-ice-blue': 'rgb(167, 198, 218)','heather-navy': 'rgb(65, 74, 85)','heather-peach': 'rgb(232, 180, 160)','indigo-blue': 'rgb(75, 0, 130)','kelly-green': 'rgb(76, 187, 23)','midnight-navy': 'rgb(27, 31, 59)','military-green': 'rgb(75, 83, 32)','mint': 'rgb(152, 216, 193)','natural': 'rgb(229, 217, 195)','rust': 'rgb(174, 78, 43)','sand': 'rgb(237, 229, 208)','soft-cream': 'rgb(242, 234, 213)','soft-pink': 'rgb(244, 194, 194)','solid-cardinal-red': 'rgb(140, 29, 64)','solid-indigo': 'rgb(75, 0, 130)','solid-military-green': 'rgb(75, 83, 32)','solid-white': 'rgb(255, 255, 255)','sport-grey': 'rgb(155, 154, 156)','warm-gray': 'rgb(168, 159, 145)','warm-grey': 'rgb(168, 159, 145)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
